export const getIntValue = <T extends { key: string; value: string }>(
  params: T[],
  key: string,
  defaultValue: string
) => parseInt(params?.find((e) => e.key === key)?.value ?? defaultValue, 10);
